// pages/trucker/CompanyTruckersList..js
import React, { useState, useEffect } from 'react'
import api from '../../services/api'
import '../../assets/css/truckerregistration.css'

export default function CompanyTruckersList() {
  const [truckers, setTruckers] = useState([])
  const [status, setStatus] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10)
    setStartDate(today)
    setEndDate(today)
  }, [])

  useEffect(() => {
    if (startDate && endDate) {
      loadTruckers()
    }
  }, [startDate, endDate])

  const loadTruckers = async () => {
    setStatus('Loading...')
    try {
      const params = {}
      if (startDate) {
        params.startDate = startDate
      }
      if (endDate) {
        params.endDate = endDate
      }
      const r = await api.get('/trucker/company-truckers', { params })
      setTruckers(r.data.truckers)
      setStatus('')
    } catch (err) {
      setStatus('Error loading truckers')
    }
  }

  const handleFilterSubmit = e => {
    e.preventDefault()
    loadTruckers()
  }

  return (
    <div className="container page-container">
      <h2>All Company Truckers</h2>
      <form onSubmit={handleFilterSubmit} style={{ marginBottom: '20px' }}>
        <label>Start Date:</label>
        <input
          type="date"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
          style={{ marginRight: '10px' }}
        />
        <label>End Date:</label>
        <input
          type="date"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
          style={{ marginRight: '10px' }}
        />
        <button type="submit">Filter</button>
      </form>
      {status && <p>{status}</p>}
      {!status && truckers.length === 0 && <p>No truckers found.</p>}
      {!status && truckers.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0', textAlign: 'left' }}>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Created At</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Name</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Surname</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Phone</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>License Truck</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>License Trailer</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Language</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Loading #</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Freight Name</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>City</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Country</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Food Ads?</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Food Load?</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Consent Read?</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>Consent Data?</th>
                <th style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>PDF</th>
              </tr>
            </thead>
            <tbody>
              {truckers.map(t => (
                <tr key={t._id} style={{ borderBottom: '1px solid #ccc' }}>
                  <td style={{ padding: '8px' }}>{new Date(t.createdAt).toLocaleString()}</td>
                  <td style={{ padding: '8px' }}>{t.plainName}</td>
                  <td style={{ padding: '8px' }}>{t.plainSurname}</td>
                  <td style={{ padding: '8px' }}>{t.plainPhone}</td>
                  <td style={{ padding: '8px' }}>{t.plainLicensePlateTruck}</td>
                  <td style={{ padding: '8px' }}>{t.plainLicensePlateTrailer}</td>
                  <td style={{ padding: '8px' }}>{t.preferredLanguage}</td>
                  <td style={{ padding: '8px' }}>{t.loadingNumber}</td>
                  <td style={{ padding: '8px' }}>{t.freightCompanyName}</td>
                  <td style={{ padding: '8px' }}>{t.freightCompanyCity}</td>
                  <td style={{ padding: '8px' }}>{t.freightCompanyCountry}</td>
                  <td style={{ padding: '8px' }}>{t.hasFoodAdvertising ? 'Yes' : 'No'}</td>
                  <td style={{ padding: '8px' }}>{t.isFoodLoad ? 'Yes' : 'No'}</td>
                  <td style={{ padding: '8px' }}>{t.consentReadEverything ? 'Yes' : 'No'}</td>
                  <td style={{ padding: '8px' }}>{t.consentStoreData ? 'Yes' : 'No'}</td>
                  <td style={{ padding: '8px' }}>
                    {t.registrationPdfUrl ? (
                      <a href={t.registrationPdfUrl} target="_blank" rel="noopener noreferrer">View PDF</a>
                    ) : (
                      'No PDF'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}